// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const medicham: PokeData = {
  "id": 308,
  "name": "medicham",
  "height": 13,
  "weight": 315,
  "base_experience": 144,
  "types": [
    PokeType.FIGHTING,
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "pound",
    "fire-punch",
    "ice-punch",
    "thunder-punch",
    "psybeam",
    "low-kick",
    "counter",
    "confusion",
    "meditate",
    "recover",
    "bide",
    "high-jump-kick",
    "mind-reader",
    "reversal",
    "detect",
    "endure",
    "swagger",
    "hidden-power",
    "psych-up",
    "calm-mind",
    "feint",
    "acupressure",
    "power-trick",
    "force-palm",
    "zen-headbutt",
    "work-up",
    "axe-kick"
  ],
  "moves": [
    "fire-punch",
    "ice-punch",
    "thunder-punch",
    "calm-mind",
    "zen-headbutt",
    "double-kick",
    "coaching",
    "future-sight",
    "close-combat",
    "psychic-terrain",
    "karate-chop",
    "bulk-up",
    "psy-ball"
  ],
  "evolution_chain": {
    "id": 152,
    "item": null,
    "species": [
      {
        "name": "meditite",
        "order": 333,
        "types": [
          PokeType.FIGHTING,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "medicham",
        "order": 334,
        "types": [
          PokeType.FIGHTING,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 307,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 37,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 130,
    "speed": 154,
    "ability_power": 116
  },
  "stat_changes": [],
  "catch_rate": 90,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
